import Layout from 'web/components/Layout'
import GalleryHeader from 'web/components/GalleryHeader'
import GalleryGawdItems from 'web/components/GalleryGawdItems'
import { NextSeo } from 'next-seo'

import { getContractData } from 'web/lib/contract'
import Gawd from 'web/lib/gawd'

import { useContext, useEffect, useState } from 'react'
import { StoreContext } from 'web/lib/store'
import { useWeb3React } from '@web3-react/core'
import CultGame from 'web/components/CultGame'
import useMyGawds from 'web/hooks/useMyGawds'
import GalleryTabs, { Tab } from 'web/components/GalleryTabs'
import GalleryBoonItems, { BoonGalleryContext } from 'web/components/GalleryBoonItems'
import useMyBoons from 'web/hooks/useMyBoons'
import useEnvironment from 'web/hooks/useEnvironment'
import Link from 'next/link'

export async function getStaticProps() {
  return {
    props: {
      contractData: await getContractData(),
    },
    revalidate: 60,
  }
}

export default function Wallet({ contractData }) {
  const { account, library } = useWeb3React()

  const isConnected = typeof account === 'string' && !!library

  const { isBeta } = useEnvironment()

  const {
    gawdtchis: [gawchis]
  } = useContext(StoreContext)

  const myGawds = useMyGawds()

  // reversed so that your latest purchases show up first
  // let myGawdsSorted = myGawds.sort((a, b) => a.id() < b.id() ? 1 : -1)
  const title = 'My Sanctuary'

  const [deadGawds, setDeadGawds] = useState<Gawd[]>([])
  const [aliveGawds, setAliveGawds] = useState<Gawd[]>([])

  const showBloodGame = isBeta && account && myGawds.length > 0

  // Gallery tabs
  const [galleryItems, setGalleryItems] = useState<string>()
  function onTabSelect(tab: Tab) {
    setGalleryItems(tab.name)
  }

  // Setup the Gawd galleries
  // useEffect(() => {
  //   let gawds = myGawds.filter(gawd =>
  //     gawchis.gawds.find(gawchi =>
  //       gawd.id() == gawchi.gawdId() && !gawchi.getAlive()
  //     ) !== undefined
  //   )
  //   // console.log('gawdz', ownedTokens.length, gawchis.gawds.length)
  //   // setDeadGawds(gawds)

  //   gawds = myGawds.filter(gawd =>
  //     gawchis.gawds.find(gawchi => gawd.id() == gawchi.gawdId() && gawchi.getAlive()) !== undefined
  //   )
  //   // setAliveGawds(gawds)
  // }, [gawchis, myGawds])

  const myBoons = useMyBoons()
  const boons = myBoons.all.filter(b => b.activatable && !b.isExpired)

  return (
    <>
      <NextSeo title={title} nofollow={true} />

      <Layout initContractData={contractData}>
        <div className="animate-fadeIn relative py-8 ">

          {showBloodGame ?
            <CultGame />
            :
            <GalleryHeader initContractData={contractData} title={title} showBloodBeta={true} />}

          {showBloodGame &&
            <GalleryTabs tabs={[
              { name: "My Gawds", count: myGawds.length, selected: true, visible: true },
              { name: "Sated", count: aliveGawds?.length, visible: deadGawds?.length > 0 },
              { name: "Dead", count: deadGawds?.length, visible: deadGawds?.length > 0 },
              { name: "My Boons", count: boons.length, visible: isBeta },
            ]}
              onSelect={onTabSelect}
              className="mt-8 md:mt-0"
            />}

          {(galleryItems == 'My Gawds' || galleryItems == null) &&
            <GalleryGawdItems gawds={myGawds} isWallet={true} />}

          {galleryItems == 'Sated' &&
            <GalleryGawdItems gawds={aliveGawds} isWallet={true} />}

          {galleryItems == 'Dead' &&
            <GalleryGawdItems gawds={deadGawds} isWallet={true} />}

          {galleryItems == 'My Boons' && <>
            <GalleryBoonItems boons={boons} context={BoonGalleryContext.Wallet} />
            {boons.length == 0 &&
              <div className="w-3xl text-center mx-auto space-y-2">
                <p>You don't own any Boons.</p>
                <Link href="/exchange">
                  <button className="primaryButton">Visit the Blood Exchange</button>
                </Link>
              </div>}
          </>}

          {!isConnected &&
            <h3 className="mt-8 text-lg text-center">Connect a wallet to view your Gawds.</h3>}
        </div>
      </Layout>
    </>
  )
}
